import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_COLLECTIONS,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';

const normalizeText = (value = '') => String(value || '').trim();

export const GOAL_REVIEW_DOMAIN = 'goal';
export const GOAL_REVIEW_ALLOWED_ACTIONS = ['add_goal', 'ignore'];

export const buildGoalReviewCandidate = ({
  origin = {},
  extractedItem = {},
  confidence = '',
  suggestedAction = 'add_goal',
} = {}) => {
  const title = normalizeText(
    extractedItem.title
    || extractedItem.goal
    || extractedItem.goalText
    || extractedItem.label
    || extractedItem.description
    || extractedItem.sourceText
  );
  const description = normalizeText(extractedItem.description || extractedItem.details);
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || title || description);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.KNOWLEDGE_ITEM,
    collection: origin.collection || REVIEWABLE_ORIGIN_COLLECTIONS.KNOWLEDGE_ITEMS,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: GOAL_REVIEW_DOMAIN,
      label: title || 'Goal',
      sourceText,
      allowedActions: GOAL_REVIEW_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: {
        title,
        description,
        successCriteria: normalizeText(extractedItem.successCriteria || extractedItem.criteria),
        category: normalizeText(extractedItem.category),
        source: normalizeText(extractedItem.source),
        supportStrategy: normalizeText(extractedItem.supportStrategy || extractedItem.strategy),
        status: normalizeText(extractedItem.status || 'active') || 'active',
        startDate: normalizeText(extractedItem.startDate),
        targetDate: normalizeText(extractedItem.targetDate || extractedItem.dueDate),
      },
    }),
    extracted: {
      title,
      description,
      sourceText,
    },
  };
};
